(function () {
	'use strict';
	$(document).ready(function () {

		function addToNewsletter(email, token) {
			$.ajax({
				url: "/wp/wp-admin/admin-ajax.php",
				method: "post",
				timeout: 10000,
				data: {
					action: "add_to_newsletter",
					email: email,
					recaptcha_token: token
				},
				success: function (result) {
					let data = JSON.parse(result);
					$('form.newsletter-form').html("<p class='" + (data.success ? 'success' : 'error') + "'>" + data.message + "</p>");
				},
				error: function () {
					$('form.newsletter-form').html("<p class='error'>Something gone wrong. Try again later!</p>");
				},
				beforeSend: function () {
					$('form.newsletter-form').addClass('sending');
				},
				complete: function () {
					$('form.newsletter-form').removeClass('sending');
				}
			});
		}

		$('form.newsletter-form').on('submit', function(e) {
			e.preventDefault();
			const email = $('.footer .newsletter-form input').val();

			getRecaptchaToken(function(token) {
				addToNewsletter(email, token);
			});
		});
	});
}(jQuery));
